import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, css, Stack } from '@mui/material';

import { useLayerDashboardTabStore } from 'features/layer-dashboard/context/LayerDashboardContext';
import { ILayerDashboard, ILayerGroupDashboardMainResponse } from 'features/layer-dashboard/model/ILayerDashboardMainResponse';
import { CardChart } from 'features/layer-dashboard/components/CardChart';
import { Filter } from 'features/layer-dashboard/components/Filter';
import { Map } from '../../features/layer-dashboard/components/Map';
import { GeopostAppBar } from 'components/geopostAppBar/GeopostAppBar';
import { SummaryInfo } from 'features/layer-dashboard/components/SummaryInfo';

const styles = css({
    background: '#c8c8c8',
    '& .container-master': {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 8,
        paddingBottom: 8,
        boxSizing: 'border-box',
        height: 'calc(100% - 132px)'
    },
    '& .stack-row': {
        width: '100%',
        height: '50%',
        boxSizing: 'border-box',
    },
    '.container-loading': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0, 0.5)',
        zIndex: 9999999999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&.hidden': {
            display: 'none'
        }
    }
});

export const SummaryDashboardTab = ({data}: SummaryDashboardTabProps) => {
    const { t } = useTranslation(['common']);

    const { setResponse } = useLayerDashboardTabStore((state) => ({
        clear: state.clear,
        displayableData: state.displayableData,
        recalculate: state.recalculate,
        setDisplayableData: state.setDisplayableData,
        setResponse: state.setResponse,
        title: state.title,
    }));

    const [maximizedView, setMaximizedView] = useLayerDashboardTabStore((state) => [state.maximizedView, state.setMaximizedView]);

    useEffect(() => {
        if (data) {
            let allData = [];
            for (let i = 0; i < data.DashboardLayers.length; i++) {
                for (let j = 0; j < data.DashboardLayers[i].Data.length; j++) {
                    let dataAdjustment = data.DashboardLayers[i].Data[j];
                    dataAdjustment = dataAdjustment.slice(0, -1);
                    dataAdjustment += `,\"layer_title\":\"${data.DashboardLayers[i].Title}\"}`;

                    allData.push(dataAdjustment);
                }
            }

            let newData: ILayerDashboard = {
                Attributes: data.Summary,
                Data: allData,
                JsonConfig: {},
                LayerSource: '',
                Title: ''
            };

            setResponse(newData);
        }
    }, [data]);

    return (
        <Stack direction='column' width='100vw' height='100vh' css={styles}>
            <GeopostAppBar title={'Dashboard - Sumário' } />
            <Stack className='container-master' direction='column' flexGrow={1} spacing={1}>
                <Stack className='stack-row' direction='row' spacing={1} style={{display: maximizedView !== '' ? 'none' : 'flex'}}>
                    <Box width={'30%'} height={'100%'}>
                        <CardChart>
                            <Filter></Filter>
                        </CardChart>
                    </Box>
                    <Box width={'70%'} height={'100%'}>
                        <Map></Map>
                    </Box>
                </Stack>
                <Stack className='stack-row' direction='row' spacing={1} style={{height: maximizedView !== '' ? '100%' : '50%'}}>
                    <Box width='100%' height='93%'>
                        <CardChart>
                            <SummaryInfo summaryInfo={data?.SummaryInfo ?? ''} />
                        </CardChart>
                    </Box>
                </Stack>
            </Stack>
        </Stack>
    );
};

interface SummaryDashboardTabProps {
    data: ILayerGroupDashboardMainResponse | undefined
}